import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordForm } from '@/features/auth/forgot-password-form';

export const Route = createFileRoute('/_public/forgot-password')({
  component: ForgotPasswordForm,
});
